module.exports = __webpack_public_path__ + "static/media/baseball.caad1c74.jpg";